import { gql } from 'graphql-request';

const UpdateStoryMutation = gql`
  mutation UpdateStory(
    $id: ID!
    $title: String
    $summary: String
    $footnotes: String
    $before_chart_content: String
    $after_chart_content: String
    $state: String
  ) {
    update_story_by_id(
      id: $id
      title: $title
      summary: $summary
      footnotes: $footnotes
      before_chart_content: $before_chart_content
      after_chart_content: $after_chart_content
      state: $state
    ) {
      __typename

      ... on story {
        id
        title
        slug
        summary
        footnotes
        before_chart_content
        after_chart_content
        state
        last_state_transition_at
        first_published_at
        state_transitions {
          state
          transitioned_by
          transitioned_at
        }
        updated_at
      }

      ... on i_error {
        message
      }
    }
  }
`;

export default UpdateStoryMutation;
